import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { getAppLocale, setAppLocale, type AppLocale } from "@/i18n";
import { LOCALE_LABELS, SELECTABLE_LOCALES } from "@/i18n/locales";

/**
 * Active product locale and a setter that persists the choice (ADR-076).
 *
 * `locales` is the list the UI may offer (`es-AR` and `en-GB`).
 */
export function useLocale(): {
  locale: AppLocale;
  setLocale: (locale: AppLocale) => Promise<void>;
  locales: typeof SELECTABLE_LOCALES;
  labels: typeof LOCALE_LABELS;
  /** False while only one language is offered — hide the control. */
  showSwitcher: boolean;
} {
  const { i18n } = useTranslation();
  // Re-render when the language changes; `getAppLocale` reads i18n.language.
  void i18n.language;

  const setLocale = useCallback(async (locale: AppLocale) => {
    await setAppLocale(locale);
  }, []);

  return {
    locale: getAppLocale(),
    setLocale,
    locales: SELECTABLE_LOCALES,
    labels: LOCALE_LABELS,
    showSwitcher: SELECTABLE_LOCALES.length > 1,
  };
}
